module.exports = __webpack_public_path__ + "img/enter.9917af42.svg";